import { z } from 'zod'
import {
  AreaCodeSchema,
  RecommendationKindSchema,
  RecommendationSeveritySchema,
} from '../enums.js'

export const RecommendationSchema = z.object({
  id: z.string().min(1),
  rule_id: z.string().regex(/^R-\d{3}$/),
  severity: RecommendationSeveritySchema,
  kind: RecommendationKindSchema,
  title: z.string().min(1),
  message: z.string().min(1),
  area: AreaCodeSchema.optional(),
  affects: z.array(z.string().min(1)),
})
export type Recommendation = z.infer<typeof RecommendationSchema>
